
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  projectListHeadline: {
    id: "projectListHeadline.headline",
    defaultMessage: "List of Constructions",
  },
  projectListAdd: {
    id: "ProjectListAdd.addText",
    defaultMessage: "Add New Adress",
  },
});

export default MESSAGES;